import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';

function StaffRoute() {

  const { currentStaff } = useSelector((state) => state.staff);

  return (
    currentStaff ? ( <Outlet /> ) : (<Navigate to={'/sign-in'} />)
  );
};

export default StaffRoute;